// extracted by css-extract-rspack-plugin
export default {"card":"CopilotBudgetRequestCard-module__card__Ao0WC","iconCircle":"CopilotBudgetRequestCard-module__iconCircle__WariC"};